<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          2020 @
          <a href="https://www.99gift.in" target="_blank">www.99gift.in</a>
        </div>
        <div class="col-md-6">
          <div class="text-md-right footer-links d-none d-sm-block">
            <a href="javascript:void(0);">{{ welcomeText }}</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>

  export default {

    data() {
      return {
        welcomeText: ''
      }
    },
    mounted(){

      const hours = new Date().getHours()

      if (hours < 12) {
       this.welcomeText = ('Good Morning')
      } else if (hours < 18) {
        this.welcomeText = ('Good Afternoon')
      } else {
        this.welcomeText = ('Good Evening')
      }
    }
  }

</script>